module.exports = __webpack_public_path__ + "img/VallabH.89f43d8c.jpg";